import { Box, Card, Flex, Text, Title } from "@mantine/core";
import DisabledContainer from "@common/components/layout/DisabledContainer";
import { formatPrice, tokenize } from "@common/utils/string";
import { NUMBER_FORMAT_PRICE_OPTIONS } from "@common/utils/string/constants";
import { ReactElement, ReactNode } from "react";
import { AddOnProductType } from "@stores/addons/types";

export interface IAddOnCardProps {
  productType?: AddOnProductType;
  title: string;
  isYearly: boolean;
  detail?: string | null;
  price?: number | null;
  badge?: ReactNode;
  extra?: ReactNode;
  description?: ReactNode;
  usage?: ReactNode | null;
  disabled?: boolean;
}

export function AddOnCard({
  isYearly,
  productType,
  title,
  detail,
  price,
  badge,
  extra,
  description,
  usage,
  disabled = false,
}: IAddOnCardProps): ReactElement | null {
  const billingFrequencyText = isYearly ? "year" : "month";

  const testId = `AddOnCard_${productType ?? tokenize(title)}`;

  return (
    <DisabledContainer data-testid={testId} disabled={disabled}>
      <Card withBorder p="xl">
        <Flex
          data-testid={`${testId}_header`}
          align="baseline"
          justify="space-between"
        >
          <Title order={3} size="h4" mb="sm">
            <Text span>{title}</Text>
            {badge}
            {detail && (
              <>
                <Text span> - </Text>
                <Text span>{detail}</Text>
              </>
            )}
            {!price ? null : (
              <Text component="span" c="gray.5">
                <Text component="span" fz="xs" px="xs" top={-2} pos="relative">
                  •
                </Text>
                <Text span>
                  {formatPrice(price, NUMBER_FORMAT_PRICE_OPTIONS)}/
                  {billingFrequencyText}
                </Text>
                .
              </Text>
            )}
          </Title>

          {extra || <Box />}
        </Flex>

        {description && (
          <Text c="gray.4" size="sm" maw={660}>
            {description}
          </Text>
        )}

        {usage && (
          <Box mt={description ? "xs" : undefined} w="100%">
            {usage}
          </Box>
        )}
      </Card>
    </DisabledContainer>
  );
}
